import React from 'react';
import metaASPLogo from 'images/ASP-badge-outlined_600px-trimmed.png';
import {setTestId} from 'js/reusable/testing/setTestId';

type IProps = {
    simple?: boolean;
}

function MetaLogo({simple}: IProps) {
	if (simple) {
		return (
			<span className="tw-mt-3">
				<strong>A Meta</strong> Authorized Sales Partner
			</span>
		);
	}

	return (
		<img 
			src={metaASPLogo}
			alt=""
			className="tw-h-full"
			data-testid={setTestId('logo__meta-logo-img')}
		/>
	);
}

export default MetaLogo;
